var constants = {
   //baseUrl: "https://checkpointtesttestapi.cngsystems.co.uk",
   //baseClientUrl: "https://checkpointtest.cngsystems.co.uk",

    baseUrl: "https://checkpointtestapi.cngsystems.co.uk",
    baseClientUrl: "https://checkpoint.cngsystems.co.uk",

  // baseUrl: 'https://apitest.cngsystems.co.uk',
  // baseClientUrl: 'https://cptest.cngsystems.co.uk'

  //baseUrl: "http://localhost:5000",
  //baseClientUrl: "http://localhost:5000",

  // baseUrl: 'https://apitest.cngsystems.co.uk',
  // baseClientUrl: 'https://cptest.cngsystems.co.uk'

 // baseUrl: "http://localhost:54515",
 // baseClientUrl: "http://localhost:3000",

  // Max visible-character length for the Site Log rich-text note fields.
  // Counts plain visible text (not HTML markup). `null` = uncapped (the backing
  // columns are nvarchar(max)); the character counter still shows the running
  // count. Set a number here to reinstate a hard cap across every rich-text note
  // field + Incident Notes at once.
  richTextMaxLength: null,

  // Max character length for the Control Log free-text areas. `null` = uncapped
  // (varchar(max) columns); the counter still shows. Set a number here to
  // reinstate a hard cap across all Control Log textareas.
  controlLogTextMaxLength: null,
};

export default constants;
